import React from "react";
import { Link } from "react-router-dom";
import { HOME_CTA_DARK_OUTLINE } from "../../lib/homeCta";

/** Small visual mix-ins teaser — education lives on /mix-ins. */
export default function HomeCustomHerbsNote() {
  const thumb = `${process.env.PUBLIC_URL || ""}/images/lifestyle/natural-ingredients-dark.jpg`;

  return (
    <section
      id="builder"
      className="py-6 md:py-8 scroll-mt-24 border-y border-[rgba(248,241,223,0.1)]"
      aria-labelledby="custom-herbs-heading"
    >
      <div className="max-w-xl mx-auto px-6 md:px-10">
        <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-5 text-center sm:text-left">
          <div className="relative w-full sm:w-28 h-24 sm:h-28 shrink-0 overflow-hidden rounded-xl border border-[rgba(248,241,223,0.14)]">
            <img
              src={thumb}
              alt=""
              className="absolute inset-0 w-full h-full object-cover brightness-110 contrast-105"
              loading="lazy"
              decoding="async"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[rgba(5,7,6,0.35)] to-transparent" aria-hidden />
          </div>
          <div className="min-w-0 flex-1">
            <h2 id="custom-herbs-heading" className="font-sans font-semibold text-lg md:text-xl text-ivory m-0 leading-snug">
              Mix-in ideas
            </h2>
            <p className="mt-2 text-sm md:text-[15px] text-sage leading-relaxed m-0">
              Explore ginger, turmeric, cinnamon and other ingredients people commonly pair with sea moss.
            </p>
            <Link to="/mix-ins" className={`${HOME_CTA_DARK_OUTLINE} mt-3.5 min-h-[42px] px-5 py-2 text-xs inline-flex`}>
              Explore Mix-Ins
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
